export interface IPrintWorkShiftReportProps {
  onAfterPrint?: VoidFunction;
  comment?: string;
  disabled?: boolean;
}

import { ICashOrder, IWorker, TPayment } from 'types';

export interface IBasePrintItem {
  title: string;
  amount: number;
  sum: number;
}

export type IServicesPrintItem = IBasePrintItem;

export type ICombosPrintItem = IBasePrintItem;

export interface IGoodsPrintItem extends IBasePrintItem {
  in_stock: number;
  cost: number;
}

export interface IGetWorkShiftDataResponse {
  getWorkShiftPaymentOverviewData: {
    id: number;
    total: number;
    cash: number;
    card: number;
    deposit: number;
    online_deposit: number;
    cash_on_start: number;
    bonus: number;
    created_at: string;
    sum: {
      good: number;
      service: number;
      deposit: number;
      tariff: number;
      tips: number;
    };
    cash_orders: Array<
      Pick<ICashOrder, 'type' | 'comment' | 'created_at' | 'sum'>
    >;
    worker: Pick<IWorker, 'uuid' | 'first_name' | 'last_name'>;
    goods: IGoodsPrintItem[];
    combos: ICombosPrintItem[];
    services: IServicesPrintItem[];
  };
  activeWorkShift: {
    payments: Array<Pick<TPayment, 'method' | 'status'>>;
  };
}

export type FormEndWorkShiftModalValues = {
  comment: string;
  password: string;
};

export interface IEndWorkShiftFormProps {
  onClose: () => void;
}

export const enum ESteps {
  DETAILS,
  CONFIRM,
  CLOSED,
  POST_PAYMENTS,
}
